export default __webpack_public_path__ + "static/media/login-bg.84e93324.jpg";